import React, { Fragment } from "react";
import { ProgressBar } from "react-bootstrap";
import { Label } from "../InputField1/InputFiled1Style";
import { ProgressBarBsStyle } from "./ProgressBarBsStyle";
const ProgressBarBs = ({ label, percentage, color }) => {
  return (
    <ProgressBarBsStyle color={color}>
      <Label color="#808080">{label}</Label>
      <ProgressBar now={percentage} />
    </ProgressBarBsStyle>
  );
};

export default ProgressBarBs;
